import ProifleDetails from "../components/user/profiledetails";
import Slide from 'react-reveal/Slide';
import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';
import {AiFillWarning} from 'react-icons/ai';
import { useParams } from "react-router-dom";
import useVerifyUser from "../controllers/useverifyuser";
import { useRef } from "react";
export default function VerifyUser(){
    const {token}=useParams();
    const {account,loading,data,url,handleChange,changeDp,submit}=useVerifyUser(token);
  
  if(!account)
  return "Loading..";
    return (
        <div>
            <div className="bg-[url('http://localhost:3000/hill.jpg')] w-[90%] bg-cover h-[200px] bg-no-repeat bg-left m-auto mt-4 rounded-lg">
            </div>
            <div className="m-auto w-[85%] shadow-lg -mt-4 bg-white rounded-lg p-4"  >
                <div className="flex space-x-2">
                    <Fade top>
                        <input type="file" className="w-[1px] h-[1px] hidden" id="dp-upload" onChange={changeDp}/>
                    <img src={url || data.profileurl} alt="Profile" className="w-20 h-20 rounded-lg"
                    onClick={()=>{if(!loading)document.getElementById("dp-upload").click()}}
                    />
                    </Fade>
                    <Zoom>
                    <div className="mt-4">
                        <p className="font-Roboto font-bold">{data.firstname+" "+data.lastname}</p>
                        <p className="font-Roboto font-medium">{data.accountType}</p>
                    </div>
                    </Zoom>
                </div>
                <div className="flex space-x-2 w-fit mt-2 mb-2">
                    <AiFillWarning className="fill-yellow-500 scale-110" />
                    <p className="font-Roboto text-red-400 text-sm tracking-wider">you can submit only once</p>
                </div>
               <div className="flex flex-wrap space-y-4 sm:space-x-10 ">
                <Slide right>
                <ProifleDetails 
                account={account}
                loading={loading}
                data={data}
                handleChange={handleChange}
                submit={submit}
                />
                    </Slide>
               
               </div>
            </div>
        </div>
    )
}